import { ReactNode, useEffect, useState} from 'react';
import { UseFormRegisterReturn, UseFormSetValue, SubmitHandler, useForm, UseFormClearErrors } from 'react-hook-form';
import { zodResolver } from "@hookform/resolvers/zod";
import { z } from "zod";
import InputField from '../Forms/InputField';
import { useBudgetDetails } from '../../providers/hooks/useBudgetDetails';
import { useLoader } from "../../hooks/useLoader";
import ApiService from '../../services/ApiServiceClass';

const budgetSchema = z.object({
    budget: z
    .number({
      required_error: "Budget is required",
      invalid_type_error: "Budget must be a number",
    })
    .positive("Budget must be a positive number"),
});

type BudgetFieldType = z.infer<typeof budgetSchema>;

const BudgetSettings = () => {

    const budgetDetails = useBudgetDetails();
    const loader = useLoader();

    const { register, handleSubmit, watch, reset, getValues, setValue, setFocus, formState: { errors, isSubmitting } } = useForm<BudgetFieldType>({
        defaultValues: {
            
        },
        resolver: zodResolver(budgetSchema)
    });

    const onSubmit: SubmitHandler<BudgetFieldType> = () => {
        const formData = new FormData();

        formData.append('budget', getValues("budget").toString());

        loader?.setIsLoading(true);
        try {   
            ApiService.updateBudget(formData)
                .then(() => {
                    loader?.setIsLoading(false);
                    budgetDetails?.fetchBudgetDetails();
                })
        } catch(error) {
            loader?.setIsLoading(false);
        }
    }

    const onInvalid = (errors: any) => {
        console.log(errors);
    }

    useEffect(() => {
        const budgetValue = budgetDetails?.yearlyBudget == undefined ? 0 : budgetDetails.yearlyBudget;
        setValue("budget", budgetValue);
    }, [budgetDetails?.yearlyBudget]);
    return (
        <>
            <div className="rounded-sm border border-stroke bg-white py-6 px-7.5 shadow-default dark:border-strokedark dark:bg-boxdark">
                <h5 className="text-xl font-semibold text-black dark:text-white">
                    Budget Settings
                </h5>
                <form onSubmit={handleSubmit(onSubmit, onInvalid)} >
                    <fieldset className="flex max-w-md flex-col gap-4">
                        <legend className="mb-4 mt-4">Set current yearly budget.</legend>
                        <div className="flex items-center gap-2">
                            <InputField                                
                                labelName={<>Budget</>}
                                fieldName="budget"
                                type="number"
                                step="any"
                                errors={errors}
                                placeholder="Enter budget"
                                register={register("budget", { valueAsNumber: true })}    
                            />
                        </div>
                    </fieldset>
                    <button type="submit"
                                        className="text-white bg-gradient-to-r from-blue-500 via-blue-600 to-blue-700 hover:bg-gradient-to-br focus:ring-4 focus:outline-none focus:ring-blue-300 dark:focus:ring-blue-800 font-medium rounded-lg text-sm px-5 py-2.5 text-center mb-10 mr-2"
                                    >
                        Update Budget
                    </button>
                </form>
            </div>        
        </>
    )
}

export default BudgetSettings;